<div style="border: 5px ridge; padding: 4px" *ngIf="isReady" [class.search-disabled]="this.readonly">
	<app-search
		#appSearch
		class="mt-md"
		[searchOnLoad]="searchOnLoad"
		[showCriteria]="showCriteria"
		[customizeKey]="saveStateKey"
		[saveStateKey]="saveStateKey"
		[searchId]="searchId"
		[displayMode]="displayMode"
		[criteriaValues]="criteriaValues"
		[requiredValues]="requiredValues"
		[useSpecificCriteriaLabel]="useSpecificCriteriaLabel"
		[criteriaLabel]="criteriaLabel"
		[allowSingleSelect]="true"
		[allowDoubleClick]="false"
		[serviceSearchSettings]="serviceSearchSettings"
		[skipAutoClickPersonAfterSearch]="skipAutoClickPersonAfterSearch"
		[isMainSearch]="isMainSearch"
		[canFilterText]="canFilterText"
		[canExport]="canExport"
		[canCustomizeView]="canCustomizeView"
		[healthTrackMode]="healthTrackMode"
		[hidePagination]="hidePagination"
		(selectedRowsChanged)="selectedRowsChanged($event)"
		(searchStateChanged)="searchStateChanged($event)"
		(selectedCardChanged)="selectedCardChanged($event)"
	>
	</app-search>
</div>
